export default {
    id: 'QrCode',
    code: 'CN',
    text: {
      'Download QR Code': '下载二维码',
    }
  }
  


// WEBPACK FOOTER //
// ./src/components/UI/QrCode/locale.js